export enum RoleTypes {
    MarketInsights = 'marketInsights',
    TruckLoadRate = 'truckLoadRate',
    NetworkInsights = 'networkInsights',
    TruckLoadRateAdmin = 'truckLoadRateAdmin'
}

export enum RoleTypesTCX {
    MarketInsights = 'Carrier Insights User',
    TruckLoadRate = 'Transportation_Insights_User',
    NetworkInsights = 'networkInsights',
    TruckLoadRateAdmin = 'Transportation_Insights_Admin'
}

export enum TrendingType {
    unknown = 'unknown',
    up = 'up',
    down = 'down',
    flat = 'flat'
}

export enum Grade {
    Unknown = 'unknown',
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D'
}

export enum ReportType {
    Volume = 'Volume',
    Price = 'Avg. Price',
    Transit = 'Transit Time',
    Speed = 'Avg. Speed',
    Revenue = 'Avg. Revenue'
}

export enum EnumProcessStatus {
    Uploaded = 'UPLOADED',
    Started = 'STARTED',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    WaitingFuelRates = 'WAITING-FUEL-RATES',
    BuildingFile = 'BUILDING-FILE'
}

export enum EnumPaymentStatus {
    NotStarted = 'NOT-STARTED',
    Started = 'STARTED',
    Completed = 'COMPLETED',
    Failed = 'FAILED'
}

export enum EnumFilenameSortBy {
    Id = 'Id',
    FileName = 'File Name',
    ProcessStatus = 'Process Status',
    PaymentStatus = 'Payment Status',
    By = 'Email'
}

export enum EnumSortDirection {
    Ascending = 'asc',
    Descending = 'desc'
}

// TODO: see if these can be combined with the above enum and/or fix them once we have details on the service
export enum NetworkInsightsReportType {
    Volume = 'Order Volume',
    AveragePrice = 'Average Price',
    HaulLength = 'Length of Haul',
    EmptyMiles = 'Empty Miles',
    MilesPerHour = 'Miles per Hour',
    RevenuePerHour = 'Revenue per Hour',
    DwellTime = 'Dwell Time',
    InTransitDelay = 'In Transit Delay'
}

export enum SnackbarMessageVariants {
    Default = 'default',
    Success = 'success',
    Error = 'error',
    Warning = 'warning',
    Info = 'info'
}

export enum EquipmentTypeValues {
    DryVan = 'VN',
    FlatBed = 'FB',
    Refrigerated = 'RF'
}

export enum UsaStateCodes {
    AL = 'AL',
    AK = 'AK',
    AZ = 'AZ',
    AR = 'AR',
    CA = 'CA',
    CO = 'CO',
    CT = 'CT',
    DC = 'DC',
    DE = 'DE',
    FL = 'FL',
    GA = 'GA',
    HI = 'HI',
    ID = 'ID',
    IL = 'IL',
    IN = 'IL',
    IA = 'IA',
    KS = 'KS',
    KY = 'KY',
    LA = 'LA',
    ME = 'ME',
    MD = 'MD',
    MA = 'MA',
    MI = 'MI',
    MN = 'MN',
    MS = 'MS',
    MO = 'MO',
    MT = 'MT',
    NE = 'NE',
    NV = 'NV',
    NH = 'NH',
    NJ = 'NJ',
    NM = 'NM',
    NY = 'NY',
    NC = 'NC',
    ND = 'ND',
    OH = 'OH',
    OK = 'OK',
    OR = 'OR',
    PA = 'PA',
    RI = 'RI',
    SC = 'SC',
    SD = 'SD',
    TN = 'TN',
    TX = 'TX',
    UT = 'UT',
    VT = 'VT',
    VA = 'VA',
    WA = 'WA',
    WV = 'WV',
    WI = 'WI',
    WY = 'WY'
}

export enum UsaTerritoryCodes {
    GU = 'GU'
}

export enum CanadianProvinceCodes {
    AB = 'AB',
    BC = 'BC',
    MB = 'MB',
    NB = 'NB',
    NL = 'NL',
    NS = 'NS',
    NT = 'NT',
    NU = 'NU',
    ON = 'ON',
    PE = 'PE',
    QC = 'QC',
    SK = 'SK',
    YT = 'YT'
}

export enum DirectionType {
    Inbound = 'inbound',
    Outbound = 'outbound'
}

export enum AppConstants {
   GridRefreshTimeout = 15000
}
